import React, { Fragment, useState, useEffect } from 'react'
import { Col, Row } from 'reactstrap';


export const ComponentPatient = (props) => {

    const {

        // * INFORMATION GENERAL
        informationPatient,
        getAgeDetail,
        url_helen,
        buap,
        handleUpdatePatient,
        pyrsa,
        _edit,
        isEditWorkOrder,

        // * QUOTER
        handleSearchQuoter,

        // * UPLOAD MEDICAL ORDER
        handleOnChange,
        DeleteFile,
        hasFile,

        // * UPLOAD MASSIVE
        checkTypeClient,
        handleDownload,
        handleFileUpload,
        massiveLoad,
        massiveSamplig,
        toggleModalErrorMasiveLoad,
        handleDeleteMassive,
        nim_Notification,
        hospitalized,

        // * VALDATE ORDER MEDICAL
        valid_medical_order,
        setShowMedicalOrderPreview,
        showMedicalOrderPreview


    } = props;


    if (!(informationPatient?.name || checkTypeClient === 2)) return null;


    // ? CONFIGURATION VALDIATE ORDER MEDICAL 




    return (
        <div className="pd-container">
            <div className="pd-header-blue pb-2">
                <Row>
                    <Col sm="11">
                        {
                            checkTypeClient !== 2 && < div className="patient-card horizontal">

                                <div className="avatar">
                                    <img
                                        className="rounded-circle"
                                        src={
                                            informationPatient.gender?.toUpperCase() === "MASCULINO"
                                                ? require("../../../assets/images/user/hombre.png")
                                                : informationPatient.gender?.toUpperCase() === "FEMENINO"
                                                    ? require("../../../assets/images/user/mujer.png")
                                                    : require("../../../assets/images/user/user.png")
                                        }
                                        style={{ width: "37px", height: "35px" }}
                                        alt="Avatar"
                                    />

                                    <span className="status-dot"></span>
                                </div>


                                <div className="patient-info">
                                    <div className="patient-name-wrapper">
                                        <div
                                            className={
                                                informationPatient.gender?.toUpperCase() === "FEMENINO"
                                                    ? "patient-name-F"
                                                    : "patient-name-M"
                                            }
                                        >
                                            {informationPatient.name + " " +
                                                informationPatient.paternal_surname + " " +
                                                informationPatient.maternal_surname}

                                            &nbsp;&nbsp;

                                            {isEditWorkOrder && (
                                                <span className="nim-mobile">
                                                    Nim: {nim_Notification}
                                                </span>
                                            )}

                                            {hospitalized === true && (
                                                <span className="hospitalized-inline">
                                                    <span className="hospitalized-indicator"></span>
                                                    Paciente en hospitalización
                                                </span>
                                            )}
                                        </div>

                                        {hospitalized === true && (
                                            <div className="patient-hospitalized-label hospitalized-bottom">
                                                <span className="hospitalized-indicator"></span>
                                                <span>Paciente en hospitalización</span>
                                            </div>
                                        )}

                                    </div>
                                    <div className="patient-inline">

                                        <span>
                                            <i className="fa fa-venus-mars"></i>
                                            {informationPatient.gender}
                                        </span>
                                        <span>

                                            <i className="fa fa-calendar"></i>
                                            {informationPatient.birthday
                                            }
                                        </span>
                                        <span>
                                            <i className="fa fa-birthday-cake"></i>
                                            {
                                                informationPatient.age > 0
                                                    ? `${informationPatient.age} años`
                                                    : getAgeDetail(informationPatient.birthday)
                                            }
                                        </span>

                                        <span>
                                            <i className="fa fa-phone"></i>
                                            {informationPatient.phone || "No registrado"}
                                        </span>

                                        <span>
                                            <i className="fa fa-envelope"></i>
                                            {informationPatient.email || "No registrado"}
                                        </span>

                                        <span className={url_helen === buap ? "" : "d-none"} >
                                            <i className="fa fa-folder"></i>
                                            {informationPatient.matricula_buap ? informationPatient.matricula_buap : <b>Sin Matrícula</b > || "No registrado"}
                                        </span>




                                        <span className={url_helen === pyrsa ?
                                            _edit === "True" ? 'mt-1' : 'd-none'
                                            : ''}>

                                            <span
                                                className={
                                                    url_helen === pyrsa
                                                        ? _edit === "True"
                                                            ? ""
                                                            : "d-none"
                                                        : ""
                                                }
                                            >
                                                <button
                                                    outline
                                                    onClick={handleUpdatePatient}
                                                    className="btn-edit-patient btn-edit-mobile"
                                                >
                                                    <i className="icofont icofont-ui-edit"></i>
                                                </button>
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        }
                        {
                            // ! UPLOAD MASSIVE
                        }
                        {
                            checkTypeClient === 2 && <div className="patient-card horizontal">
                                {
                                    massiveSamplig.numPatients === 0 && <>
                                        <div className="avatar">
                                            <img
                                                className="rounded-circle"
                                                src={
                                                    require("../../../assets/images/user/user.png")
                                                }
                                                style={{ width: "37px", height: "35px" }}
                                                alt="Avatar"
                                            />
                                        </div>
                                        <div className="patient-info">

                                            <div className="patient-name">
                                                <i className='pi pi-info-circle' ></i> &nbsp;
                                                No se a realizado una carga masiva de pacientes
                                            </div>

                                        </div>

                                    </>

                                }
                                {!massiveLoad && massiveSamplig.numPatients > 0 && (
                                    <div className="patient-info">
                                        <div className="patient-inline2">
                                            <span>
                                                <i className="fa fa-users"></i>Total de pacientes<br />
                                                <span>{massiveSamplig.numPatients}</span>
                                            </span>
                                            <span>
                                                <i className="fa fa-user-plus"></i>No. pacientes nuevos <br />
                                                <span>{massiveSamplig.numNewPatients}</span>
                                            </span>
                                            <span>
                                                <i className="fa fa-user"></i>Pacientes existentes <br />
                                                <span>{massiveSamplig.numExistingPatients}</span>
                                            </span>
                                            <span>
                                                <i className="pi pi-percentage f-12"></i> Pacientes nuevos <br />
                                                <span>{massiveSamplig.percNewPatients}%</span>
                                            </span>
                                            <span>
                                                <i className="fa fa-exclamation-triangle"></i>Pacientes con errores <br />
                                                <span>{massiveSamplig.numPatientsWithError}</span>
                                            </span>
                                            <span>
                                                <i className="fa fa-check-circle"></i>Pacientes válidos <br />
                                                <span>{massiveSamplig.numValidPatients}</span>
                                            </span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        }

                    </Col>
                    {
                        (checkTypeClient !== 2) && <Col sm="1" className="p-l-0 p-r-0 d-flex gap-2 justify-content-center align-items-center hide-mobile-actions">
                            {
                                !isEditWorkOrder && <button
                                    onClick={() => handleSearchQuoter()}
                                    className="btn-edit-quoter"
                                    title='Cargar cotizacion'
                                >
                                    <i className="icofont icofont-cloud-upload f-24"></i>
                                </button>
                            }

                            <div className='pt-2'>
                                <label
                                    className={`btn-edit-upload ${(hasFile || (isEditWorkOrder && valid_medical_order)) ? "loaded" : ""}`}
                                    title={
                                        (isEditWorkOrder && valid_medical_order)
                                            ? "Ver / cambiar orden médica"
                                            : hasFile
                                                ? "Eliminar orden médica"
                                                : "Cargar orden médica"
                                    }
                                    onClick={(e) => {
                                        if (isEditWorkOrder && valid_medical_order && !hasFile) {
                                            e.preventDefault();
                                            e.stopPropagation();

                                            setShowMedicalOrderPreview(true);
                                            return;
                                        }

                                        if (hasFile) {
                                            e.preventDefault();
                                            e.stopPropagation();

                                            DeleteFile();
                                        }
                                    }}
                                >
                                    <i
                                        className={`main-icon ${(hasFile || (isEditWorkOrder && valid_medical_order))
                                            ? "fa fa-eye f-18"
                                            : "fa fa-picture-o f-20"
                                            }`}
                                    ></i>                                    {
                                        hasFile && (<i className="pi pi-trash delete-icon"></i>)
                                    }

                                    {/* {
                                        !hasFile && isEditWorkOrder && valid_medical_order && (<i className="fa fa-eye preview-icon"></i>)
                                    } */}


                                    {
                                        !hasFile && (
                                            <input
                                                type="file"
                                                accept="image/*,.pdf"
                                                name="medical_order"
                                                onChange={handleOnChange}
                                                hidden
                                            />
                                        )
                                    }

                                </label>

                            </div>








                        </Col>
                    }
                    {
                        // ! UPLOAD MASSIVE
                    }
                    {
                        (massiveSamplig.numPatients === 0 && checkTypeClient === 2) && <Col sm="1" className="p-l-0 p-r-0 d-flex gap-2 justify-content-center align-items-center hide-mobile-actions "  >
                            <button
                                onClick={handleDownload}
                                className="btn-edit-download"
                                title='Descargar plantilla'
                            >
                                <i className="pi pi-cloud-download"></i>
                            </button>
                            <>
                                <input
                                    type="file"
                                    id="fileUpload"
                                    accept=".csv"
                                    style={{ display: "none" }}
                                    onChange={handleFileUpload}
                                />
                                <button
                                    onClick={() => document.getElementById('fileUpload').click()}
                                    className="btn-edit-upload"
                                    title='Cargar plantilla'
                                >
                                    <i className="pi pi-cloud-upload"></i>
                                </button>
                            </>
                        </Col>
                    }
                    {
                        (massiveSamplig.numPatients > 0 && checkTypeClient === 2) && <Col sm="1" className="p-l-0 p-r-0 d-flex gap-2 justify-content-center align-items-center">
                            <button
                                onClick={toggleModalErrorMasiveLoad}
                                className="btn-edit-download"
                                title='Detalles'
                            >
                                <i className="icofont icofont-document-search f-18"></i>
                            </button>
                            <button
                                onClick={handleDeleteMassive}
                                className="btn-edit-upload"
                                title='Eliminar carga masiva'
                            >
                                <i className="icofont icofont-trash f-18"></i>
                            </button>

                        </Col>
                    }

                </Row>
            </div>
        </div >
    )
}